import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import {
  baseAbstractModalStateZ1,
  BaseAbstractModalStateZ1,
  baseAbstractModalStateZ2,
  BaseAbstractModalStateZ2,
  baseModalState,
  BaseModalState,
} from "./atom";

/**
 * 모달 hook
 */

export function useModal() {
  const location = useLocation();
  const [baseModal, setBaseModalOriginal] = useRecoilState(baseModalState);
  const [abstractModalZ1, setAbstractModalZ1Original] = useRecoilState(baseAbstractModalStateZ1);
  const [abstractModalZ2, setAbstractModalZ2Original] = useRecoilState(baseAbstractModalStateZ2);

  // 현재 URL 경로 (pathname + search)
  const currentPath = useMemo(() => {
    return location.pathname + location.search;
  }, [location.pathname, location.search]);

  // URL 변경 시 모달 자동 닫기
  useEffect(() => {
    // baseModal 체크
    if (baseModal.isOpen && baseModal.openedAt && baseModal.openedAt !== currentPath) {
      setBaseModalOriginal((prev) => ({ ...prev, isOpen: false, openedAt: undefined }));
    }

    // abstractModalZ1 체크
    if (abstractModalZ1.isOpen && abstractModalZ1.openedAt && abstractModalZ1.openedAt !== currentPath) {
      setAbstractModalZ1Original((prev) => ({ ...prev, isOpen: false, openedAt: undefined }));
    }

    // abstractModalZ2 체크
    if (abstractModalZ2.isOpen && abstractModalZ2.openedAt && abstractModalZ2.openedAt !== currentPath) {
      setAbstractModalZ2Original((prev) => ({ ...prev, isOpen: false, openedAt: undefined }));
    }
  }, [currentPath, baseModal, abstractModalZ1, abstractModalZ2, setBaseModalOriginal, setAbstractModalZ1Original, setAbstractModalZ2Original]);

  // 기존 setter를 오버라이드해서 isOpen: true일 때 자동으로 URL 기록
  const setBaseModal = useCallback(
    (modalState: BaseModalState) => {
      setBaseModalOriginal({
        ...modalState,
        openedAt: modalState.isOpen ? currentPath : undefined,
      });
    },
    [currentPath, setBaseModalOriginal],
  );

  const setAbstractModalZ1 = useCallback(
    (modalState: BaseAbstractModalStateZ1) => {
      setAbstractModalZ1Original({
        ...modalState,
        openedAt: modalState.isOpen ? currentPath : undefined,
      });
    },
    [currentPath, setAbstractModalZ1Original],
  );

  const setAbstractModalZ2 = useCallback(
    (modalState: BaseAbstractModalStateZ2) => {
      setAbstractModalZ2Original({
        ...modalState,
        openedAt: modalState.isOpen ? currentPath : undefined,
      });
    },
    [currentPath, setAbstractModalZ2Original],
  );

  return {
    baseModal,
    setBaseModal,
    abstractModalZ1,
    setAbstractModalZ1,
    abstractModalZ2,
    setAbstractModalZ2,
  };
}
